import axios from 'api/axios'
import { ClientUser } from 'types'

export interface GetClientUsersOptions {
	client: string
	page?: number
	size?: number
	query?: string
}

export interface GetClientUsersResponse {
	records: ClientUser[]
	totalCount: number
	totalPages: number
	currentPage: number
}

const getClientUsers = async (
	options: GetClientUsersOptions
): Promise<GetClientUsersResponse> => {
	const { client, ...params } = options
	const { data } = await axios.get<GetClientUsersResponse>(
		`/client/${client}/admin`,
		{
			params: {
				page: 1,
				size: 10,
				...params,
			},
		}
	)
	return data
}

export default getClientUsers
